<ion-header>
  <ion-toolbar>
    <ion-title>Ticket {{ticket?.id}}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button [defaultHref]="defaultHref" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar *ngIf="subject" class="ion-padding">
    <p>{{subject}}</p>
  </ion-toolbar>
</ion-header>

<ion-content *ngIf="ticket">
  <div class="ion-padding" *ngIf="!ticket.ticketmessages || ticket.ticketmessages.length === 0">
    <p class="emptylist">
      Un ticket fue creado y el concesionario está pendiente de responder. Aquí podrá agregar mayor detalles al mismo.
    </p>
  </div>
  <div class="message-wrap">
    <div
      *ngFor="let ticketmessage of ticket?.ticketmessages"
      class="message"
      [class.left]=" ticketmessage.user_id != user.id "
      [class.right]=" ticketmessage.user_id === user.id "
    >
      <ion-spinner name="dots" *ngIf="ticketmessage.status === 'pending'"></ion-spinner>
      <div class="msg-detail">
        <div class="msg-info">
          <p>{{ticketmessage.created_at | timeAgo}}</p>
        </div>
        <div class="msg-content">
          <span class="triangle"></span>
          <p class="line-breaker">{{ticketmessage.message}}</p>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<ion-footer no-border [style.height]="showEmojiPicker ? '255px' : '65px'" *ngIf="ticket && ticket.status !== 3">
  <div class="input-wrap">
    <!-->ion-button fill="clear" item-right (click)="switchEmojiPicker()">
      <ion-icon name="happy" slot="icon-only"></ion-icon>
    </!ion-button-->
    <textarea
      #chat_input
      placeholder=""
      [(ngModel)]="editorMsg"
      (keyup.enter)="sendMsg()"
      (focusin)="onFocus()"
    ></textarea>
    <ion-button fill="clear" item-right (click)="sendMsg()">
      <ion-icon name="send" slot="icon-only"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
